module.exports = __webpack_public_path__ + "img/farming_4.eebc9616.png";